import { render, staticRenderFns } from "./ModelBottom.vue?vue&type=template&id=2a435952&scoped=true"
import script from "./ModelBottom.vue?vue&type=script&lang=js"
export * from "./ModelBottom.vue?vue&type=script&lang=js"
import style0 from "./ModelBottom.vue?vue&type=style&index=0&id=2a435952&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a435952",
  null
  
)

export default component.exports